
import { Component, Vue, Watch } from "vue-property-decorator";
import { apiBaseConfig, apiBaseConfigEdit } from "@/api/setting";
import MaterialSelect from "@/components/material-select/index.vue";

@Component({
    components: {
        MaterialSelect,
    },
})
export default class Config extends Vue {
    /** S Data **/

    // 添加商城表单數據
    form: any = {
        platform_name: "", // 賬號
        platform_ico: "", // 密碼
        platform_login_image: "", // 確認密碼
        document_status: 1 // 0-隐藏；1-顯示；
    };

    // 表单校验
    rules = {
        platform_name: [
            { required: true, message: "請輸入平台名稱", trigger: "blur" },
        ],
    };

    /** E Data **/

    /** S Methods **/
    // 點擊表单提交
    onSubmit(formName: string) {
        // 验证表单格式是否正確
        const refs = this.$refs[formName] as HTMLFormElement;
        refs.validate((valid: boolean): any => {
            if (!valid) return;

            this.handleBaseConfigEdit();
        });
    }

    // 編輯平台信息
    async handleBaseConfigEdit(): Promise<void> {
        await apiBaseConfigEdit({ ...this.form });
        this.getBaseConfigFunc();
    }

    // 獲取詳情
    async getBaseConfigFunc(): Promise<void> {
        const res = await apiBaseConfig();
        for (var key in res) {
            this.$set(this.form, key, res[key]);
        }
    }

    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.getBaseConfigFunc();
    }
    /** E Life Cycle **/
}
